module.exports = __webpack_public_path__ + "static/media/13.0c36d75f.jpg";